import React, { useCallback, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import './style.scss';
import { useTranslation } from 'react-i18next';
import Button from '@uncinc/uncinc-react-kitchen-sink/dist/components/Button';
import { useHistory, useLocation } from 'react-router';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import CartSummary from '../CartSummary';
import { formatCartItemsForAnalytics } from '../../../helpers/commerce';
import { cartHasDigitalProduct } from '../Checkout/helpers/digitalProductHelpers';
import { ROUTE_CHECKOUT_V2 } from '../../../config/routes';

const CartPopup = ({ setShowCartPopup, mobile }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const commerce = useSelector((state) => state.get('commerce'));

  if (location.pathname === '/cart') {
    setShowCartPopup(false);
  }

  const analyticsItems = useMemo(() => {
    return formatCartItemsForAnalytics(commerce.getIn(['cart', 'products']));
  }, [commerce]);

  const totalPrice = commerce.getIn(['cart', 'content', 'attributes', 'order_total', 'subtotal', 'number']);

  const hasDigitalProduct = useMemo(() => {
    return cartHasDigitalProduct(commerce.getIn(['cart', 'products']));
  }, [commerce]);

  const handleGoCheckout = () => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'view_cart',
        ecommerce: {
          currency: 'EUR',
          value: totalPrice,
          items: analyticsItems,
        },
      });
    }

    if (hasDigitalProduct) {
      history.push(ROUTE_CHECKOUT_V2);
    } else {
      history.push('/cart');
    }

    setShowCartPopup(false);
  };

  const escFunction = useCallback((event) => {
    if (event.key === 'Escape') {
      setShowCartPopup(false);
    }
  }, [setShowCartPopup]);

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);

    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, [escFunction]);

  return (
    <div className="CartPopup__backdrop" onClick={() => setShowCartPopup(false)}>
      <Container>
        <div
          className={mobile ? 'CartPopup PopupMobile' : 'CartPopup PopupNormal'}
          onClick={(e) => {
            // do not close modal if anything inside modal content is clicked
            e.stopPropagation();
          }}>

          <CartSummary showProducts />

          <Button className="Button Button--primary" onClick={handleGoCheckout}>{t('cart.checkout')}</Button>
          <div className="CartPopup__linethrough">
            <p><span>{t('cart.or')}</span></p>
          </div>
          <Button className="Button Button--ghost Button--primary" onClick={() => setShowCartPopup(false)}>{t('cart.closeCart')}</Button>
        </div>
      </Container>
    </div>
  );
};

export default CartPopup;
